import { CommonModule } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';

import { AlertService } from './../../shared/services/alert.service';

import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { Subject, takeUntil } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../shared/services/auth.service';
import { LoadingService } from '../../shared/services/loading.service';

@Component({
  selector: 'app-sign-in',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
  ],
  templateUrl: './sign-in.component.html',
  styleUrl: './sign-in.component.scss',
})
export class SignInComponent implements OnDestroy {
  private readonly unsubscribe$ = new Subject();
  hide = true;

  form = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required]),
  });

  constructor(
    readonly authService: AuthService,
    readonly router: Router,
    readonly loadingService: LoadingService,
    readonly alertService: AlertService,
    readonly activatedRoute: ActivatedRoute
  ) {}

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }

  loginOffice365(): void {
    this.loadingService.showLoading();

    this.authService
      .loginOffice365()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: () => {
          this.redirectTo();
          this.loadingService.closeLoading();
        },
      });
  }

  login(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.loadingService.showLoading();

    const { email, password } = this.form.value;
    this.authService
      .login(email!, password!)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: () => {
          this.redirectTo();

          this.loadingService.closeLoading();
        },
      });
  }

  redirectTo(): void {
    const returnUrl = this.activatedRoute.snapshot.queryParams['returnUrl'];

    if (returnUrl) {
      let params: { [key: string]: string } = {};
      const url = new URL(returnUrl, environment.redirectUri);
      const allParams = new URLSearchParams(url.search);

      allParams.forEach((value, key) => (params[key] = value));

      const newURL = returnUrl.split('?')[0];

      this.router.navigate([newURL], {
        queryParams: params,
      });
    } else {
      this.router.navigate(['main']);
    }
  }
}
